<template>
	<div v-if="config" class="elevation-1" style="padding: 5px">
		<h6>Streamer</h6>
		<v-layout row wrap>
			<v-text-field v-model="config.path" label="Path"></v-text-field>
			<v-text-field v-model="config.config_file" label="Config file"></v-text-field>
		</v-layout>
		<v-text-field v-model="config.params" label="Params"></v-text-field>
		<v-layout row wrap v-if="config.config">
			<v-text-field v-model="config.config.width" label="Width"></v-text-field>
			<v-text-field v-model="config.config.height" label="Height"></v-text-field>
			<v-text-field v-model="config.config.fps" label="Fps"></v-text-field>
			<v-switch v-model="config.config.interlaced" label="Interlaced"></v-switch>
		</v-layout>
		<v-switch v-model="config.active" label="Active"></v-switch>
	</div>
</template>

<script>
export default {
	props: ["value"],
	data () {
		return {
			config: this.value
		}
	},
	created: function() {
		this.$watch("config", function(newVal) {
			this.$emit("input", newVal);
		}, {deep: true});
	},
	computed: {
	}
}
</script>